var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaturalGas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.45 49.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0088ae;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.72,0A24.73,24.73,0,1,1,0,24.72,24.73,24.73,0,0,1,24.72,0Zm0,4.22a20.5,20.5,0,1,0,20.5,20.5A20.5,20.5,0,0,0,24.72,4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.3,37l-4.47-15.8H25.65V18.78H23.29v2.45H20.12L15.65,37h-2v2.63H35.28V37Zm-10,0H17l2-6.36h4.35Zm0-8.07h-3.8l1.63-6.28h2.17Zm2.36-6.28h2.18L29.52,29H25.65Zm0,14.35V30.67H30L31.7,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.29,11.15c1.43,1.45,3.22,3.27,2.36,5.72-.4,1.16,2.87-3.45,1.6-5.36s-1.92-3.27-1.6-5.27c-4,0-6.48,6.27-2.85,10.63C22.26,12.87,22.41,10.24,23.29,11.15Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturalGas);
export default __webpack_public_path__ + "static/media/natural-gas.9b07a1e38df46faffb77c83603d2c3d6.svg";
export { ForwardRef as ReactComponent };